export interface ContactInfo {
  readonly contactInfoId: number | null;
  phoneNumbers: PhoneNumber[];
  emailAddresses: EmailAddress[];
  addresses: Address[];
}

export interface EmailAddress {
  readonly emailAddressId: number | null;
  isPrimary: boolean;
  address: string;
  emailAddressTypeId: number;
}

// Sentinal to use for a PhoneNumber which hasn't had a country id set yet
export const COUNTRY_ID_NOT_SET = 0;
export interface PhoneNumber {
  readonly phoneNumberId: number | null;
  isPrimary: boolean;
  number: string;
  countryId: number;
  phoneNumberTypeId: number;
  phoneCode: string;
  countryCodeOverride: string;
}

export interface Address {
  readonly addressId: number | null;
  isPrimary: boolean;
  stateProvince: string | null;
  countryId: number | null;
  addressTypeId: number | null;
  streetAddress1: string | null;
  streetAddress2: string | null;
  city: string | null;
  postalCode: string | null;
  isWhileInUsa: boolean;
}

export function isEmailAddressSaved(email: EmailAddress) {
  return email.emailAddressId && email.emailAddressId > 0;
}

export function isPhoneNumberSaved(phone: PhoneNumber) {
  return phone.phoneNumberId && phone.phoneNumberId > 0;
}

export function isAddressSaved(address: Address) {
  return address.addressId && address.addressId > 0;
}
